import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavService } from "./shared/nav.service";
import { NavGroup } from "./shared/models/nav-group";
import { filter, takeUntil, tap } from "rxjs/operators";
import { Subject } from "rxjs";

import { NavbarRefreshService } from "./shared/navbar-refresh.service";

@Component({
  selector: "[appNav]",
  templateUrl: "./nav.component.html",
})
export class NavComponent implements OnInit, OnDestroy {
  navGroups: NavGroup[];
  private destroy$ = new Subject<void>();

  constructor(private navService: NavService, private navBarRefreshService: NavbarRefreshService) {}

  ngOnInit() {    
    this.navBarRefreshService.refresh$.subscribe(() => {
      console.log('Sidebar refresh triggered');
      this.loadSideBar(); // whatever method reloads this data in the sidebar, you just call again!
    });
    this.loadSideBar();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadSideBar() {
     this.navService.navGroups$
      .pipe(
        filter((ng) => ng != null),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (newNavGroups) =>
          (this.navGroups = newNavGroups.filter((x) => x.isVisible))
      );
  }
}
